import {Button, Checkbox, Input, Popover} from "antd";
import React, {useEffect, useState} from "react";
import {DownOutlined} from "@ant-design/icons";
import {getAllSoxe} from "../../../../api/weightSlip";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {onReloadData} from "../../../../redux/actions/layout/interaction/action";
import {mapMaxWidth} from "../extra/mapMaxWidth";
import {vnNormalize} from "../../../canMobile/weighing-slip/common/vnNormalize";

const SelectContentBienSo = (props) => {

    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    const [openKH, setOpenKH] = useState(false)
    const [search, setSearch] = useState()
    const [options, setOptions] = useState([])
    const [optionsTemp, setOptionsTemp] = useState([])
    const [defaultValue, setDefaultValue] = useState([])

    useEffect(() => {
        if (search && search !== "") {
            setOptions(optionsTemp.filter(item =>
                vnNormalize(item.toLowerCase()).indexOf(search?.toLowerCase()) >= 0
                || item.toLowerCase().indexOf(search?.toLowerCase()) >= 0
            ))
        } else {
            getAllSoxe(props.code, search).then(r => {
                setOptions(r)
                setOptionsTemp(r)
            })
                .catch(() => {
                })
        }
    }, [props.code, search])

    useEffect(() => {
        setDefaultValue(searchParams.getAll('soXe'))
    }, [openKH, searchParams])

    const mapTitle = () => {
        if (searchParams.getAll('soXe').length > 0) {
            return searchParams.getAll('soXe').join(", ")
        }

        return "Biển số: Tất cả"
    }
    const content = () => {
        return (
            <>
                {
                    searchParams.getAll('soXe').length > 0 && !search &&
                    <span style={{color: "#1890FF"}} className={"cursor-pointer"}
                          onClick={() => {
                              setDefaultValue([])
                          }}>
                    Xóa các mục chọn
                    </span>
                }
                <div style={{maxHeight: 247, overflowY: "auto"}} className={"flex-col flex"}>
                    {
                        options.map(item => (
                            <Checkbox
                                checked={defaultValue.includes(item)}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setDefaultValue(defaultValue.concat(item))
                                    } else {
                                        setDefaultValue(defaultValue.filter(data => {
                                            return data !== item
                                        }))
                                    }
                                }} style={{height: 35, alignItems: "center"}}>
                                <span className={"flex items-center h-12"}>{item}</span></Checkbox>
                        ))
                    }
                </div>
                <div>
                    <Button type={"primary"} onClick={() => {
                        submit()
                    }} style={{backgroundColor: "rgba(9,30,66,0.08)", color: "#344563"}}> Cập nhật </Button>
                    <Button type="link" onClick={() => {
                        setSearch(undefined)
                        setOpenKH(false)
                    }}> Đóng </Button>
                </div>
            </>
        )
    }

    const submit = () => {
        setOpenKH(false)
        setSearch(undefined)
        searchParams.delete("soXe")
        if (defaultValue.length > 0) {
            defaultValue.map(item => {
                searchParams.append("soXe", item)
                return []
            })
        }
        navigate(`?${searchParams.toString()}`)
        dispatch(onReloadData(!reloadData))
    }

    return (
        <Popover placement="bottomLeft"
                 title={<Input placeholder={"Tìm biển số"}
                               rootClassName={"customer_input_h30"}
                               value={search}
                               onChange={e => {
                                   setSearch(e.target.value)
                               }}/>}
                 content={options && content()}
                 trigger="click"
                 open={openKH}
                 onOpenChange={(newOpen) => {
                     setSearch(undefined)
                     setOpenKH(newOpen)
                 }}
                 overlayStyle={{width: 250, maxHeight: 350}}
                 overlayClassName={"customer_popover"}>
            <span className={"ml-4 cursor-pointer truncate"}
                  style={{maxWidth: mapMaxWidth()}}>
                {mapTitle()}
                <DownOutlined style={{marginLeft: 11, height: 5, width: 10}}/>
            </span>
        </Popover>
    )
}
export default SelectContentBienSo
